/* T FOR ALL — Size Chart. Reads the product's fit key (data-key) and renders the
   matching measurement table from tfa-size-charts.json client-side. Supports a
   cm/inch toggle and a localized A/B/C/D legend. The JSON is the single source of
   truth — edit it, not this file, to change numbers. */
(function () {
  var cache = {};
  function fetchData(url) {
    if (!cache[url]) cache[url] = fetch(url).then(function (r) { return r.json(); });
    return cache[url];
  }
  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  // Localized name for a zone letter, falling back to English then the letter.
  function zoneName(data, zone, lang) {
    var z = data.zones && data.zones[zone];
    return z ? (z[lang] || z.en || zone) : zone;
  }
  // Row header: "C · Outseam 36"" — localized base word + any inch suffix kept.
  function rowHeader(data, row, lang) {
    var base = zoneName(data, row.zone, lang);
    var m = (row.label || '').match(/\d+\s*["”]/);
    return row.zone + ' · ' + base + (m ? ' ' + m[0].replace('”', '"') : '');
  }

  function buildTable(refs, chart, data, unit, lang) {
    var table = el('table', 'tfa-szc__table');
    var thead = el('thead'), htr = el('tr');
    htr.appendChild(el('th', 'tfa-szc__zh', refs.zoneHdr));
    chart.columns.forEach(function (c) { htr.appendChild(el('th', null, c)); });
    thead.appendChild(htr);
    table.appendChild(thead);

    var tbody = el('tbody');
    chart.rows.forEach(function (row) {
      var tr = el('tr');
      tr.appendChild(el('th', 'tfa-szc__rh', rowHeader(data, row, lang)));
      (row[unit] || []).forEach(function (v) { tr.appendChild(el('td', null, String(v))); });
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);

    refs.tableWrap.innerHTML = '';
    refs.tableWrap.appendChild(table);
  }

  function buildLegend(refs, data, lang) {
    if (!refs.legend) return;
    refs.legend.innerHTML = '';
    ['A', 'B', 'C', 'D'].forEach(function (z) {
      if (!(data.zones && data.zones[z])) return;
      var li = el('li');
      li.appendChild(el('span', 'tfa-szc__badge', z));
      li.appendChild(document.createTextNode(' ' + zoneName(data, z, lang)));
      refs.legend.appendChild(li);
    });
  }

  function setup(host) {
    if (host.dataset.szcInit) return; host.dataset.szcInit = '1';

    var overlay = host.querySelector('[data-szc-overlay]');
    // Capture element refs now — open() reparents the overlay to <body>, after
    // which host.querySelector can no longer reach inside it.
    var refs = {
      tableWrap: overlay.querySelector('[data-szc-table]'),
      legend: overlay.querySelector('[data-szc-legend]'),
      title: overlay.querySelector('[data-szc-title]'),
      zoneHdr: host.getAttribute('data-i18n-zone') || 'Zone'
    };
    var key = host.getAttribute('data-key');
    var src = host.getAttribute('data-src');
    var lang = (host.getAttribute('data-lang') || 'en').toLowerCase();
    var unit = 'cm';
    var loaded = false, dataRef = null, chartRef = null;

    function fail() { refs.tableWrap.innerHTML = ''; refs.tableWrap.appendChild(el('p', 'tfa-szc__loading', '—')); }

    function load() {
      fetchData(src).then(function (data) {
        dataRef = data;
        chartRef = data.charts && data.charts[key];
        if (!chartRef) { fail(); return; }
        loaded = true;
        if (refs.title && chartRef.title) {
          refs.title.textContent = chartRef.title[lang] || chartRef.title.en || refs.title.textContent;
        }
        buildTable(refs, chartRef, dataRef, unit, lang);
        buildLegend(refs, dataRef, lang);
      }).catch(fail);
    }

    function open() {
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      overlay.hidden = false; document.body.style.overflow = 'hidden';
      if (!loaded) load();
    }
    function close() { overlay.hidden = true; document.body.style.overflow = ''; }

    host.querySelector('[data-szc-open]').addEventListener('click', open);
    overlay.querySelectorAll('[data-szc-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

    overlay.querySelectorAll('[data-szc-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        unit = b.getAttribute('data-szc-unit');
        overlay.querySelectorAll('[data-szc-unit]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        if (chartRef) buildTable(refs, chartRef, dataRef, unit, lang);
      });
    });
  }

  function init(root) { (root || document).querySelectorAll('[data-size-chart]').forEach(setup); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
